module.exports = __webpack_public_path__ + "9b0cbfdbac316d2002195959d72f3be8.pdf";